import { TProfileEdit } from "@utils/Interfaces";
import { Input, Button, Card, Checkbox, CollapseProps, Collapse } from "antd";
import Coin from "@assets/img/Coin.png";
import { useState } from "react";
import {
  CloseOutlined,
  DeleteOutlined,
  FullscreenExitOutlined,
  FullscreenOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import ExpForm from "@components/ExpForm/ExpForm";
import CollapseContent from "@components/CollapseContent/CollapseContent";
import CollapseHeader from "@components/CollapseHeader/CollapseHeader";
import Callout from "@components/Callout/Callout";

const ExperienceEdit: React.FC<TProfileEdit> = ({
  data,
  handleChangeValue,
  setAddExpForm,
}) => {
  const [activeCollapseItem, setActiveCollapseItem] = useState<string[]>([]);
  const [addExpFormVisible, setAddExpFormVisible] = useState(false);
  const [selectedExperience, setSelectedExperience] = useState<any[]>([]);
  const [guidePopover, setGuidePopover] = useState(true);
  const [numberPosition, setNumberPosition] = useState(1);
  const [formExpUpdate, setFormExpUpdate] = useState<any>([
    ...data.experience!,
  ]);
  const [formValue, setFormValue] = useState({
    company_name: "",
    position: [
      {
        position_name: "",
        start_date: "",
        end_date: "",
        description: "",
        skills: [],
      },
    ],
  });

  // HANDLE REMOVE EXPERIENCE
  const handleRemoveExperience = () => {
    const newFormExpUpdate = formExpUpdate.filter(
      (item: any) => !selectedExperience.includes(item.company_id)
    );
    setFormExpUpdate(newFormExpUpdate);
    handleChangeValue(newFormExpUpdate, "experience");
  };

  // SET DATA FOR FORM EDIT
  const handleSetFormExpUpdate = (
    value: any,
    key: string,
    expIndex: number,
    positionIndex?: number
  ) => {
    const newFormExpUpdate = [...formExpUpdate];
    if (positionIndex !== undefined) {
      if (value == formExpUpdate[expIndex].position[positionIndex][key]) {
        return;
      }
      if (key == "date") {
        const [start_date, end_date] = value;
        newFormExpUpdate[expIndex].position[positionIndex].start_date =
          start_date;
        newFormExpUpdate[expIndex].position[positionIndex].end_date = end_date;
      } else {
        newFormExpUpdate[expIndex].position[positionIndex][key] = value;
      }
    } else {
      if (key == "company_name") {
        newFormExpUpdate[expIndex][key] = value;
      }
    }

    setFormExpUpdate(newFormExpUpdate);
    handleChangeValue(newFormExpUpdate, "experience");
  };

  // SET DATA FOR FORM ADD
  const handleSetFormValue = (value: any, key: any, index?: number) => {
    if (index !== undefined) {
      const updatedExperiences = formValue.position.map((exp, idx) =>
        idx === index ? { ...exp, [key]: value } : exp
      );
      const newFormValue = { ...formValue, position: updatedExperiences };
      setFormValue(newFormValue);
      setAddExpForm?.(newFormValue);
    } else {
      const newFormValue = { ...formValue, [key]: value };
      setFormValue(newFormValue);
      setAddExpForm?.(newFormValue);
    }
  };

  // SET SELECTED EXPERIENCE
  const handleSetSelectedExperience = (checked: boolean, item?: any) => {
    if (item) {
      if (checked) {
        setSelectedExperience([...selectedExperience, item.company_id]);
      } else {
        const newSelectedItem = [...selectedExperience];
        var filteredItem = newSelectedItem.filter(
          (ite: any) => ite !== item.company_id
        );
        setSelectedExperience(filteredItem);
      }
    } else {
      if (checked) {
        var listSelected: any[] = [];
        formExpUpdate.forEach((element: any) => {
          listSelected.push(element.company_id);
        });
        setSelectedExperience(listSelected);
      } else {
        setSelectedExperience([]);
      }
    }
  };

  // ADD A EXPERIENCE FORM
  const handleAddExperienceForm = () => {
    setNumberPosition(numberPosition + 1);
    const newFormValue = { ...formValue };
    const newExpObj = {
      position_name: "",
      start_date: "",
      end_date: "",
      description: "",
      skills: [],
    };
    newFormValue.position.push(newExpObj);
    setFormValue(newFormValue);
  };

  // REMOVE A EXPERIENCE FORM
  const handleRemoveForm = (indexToRemove: any) => {
    const updatedItems = formValue.position.filter(
      (_, index) => index !== indexToRemove
    );
    setNumberPosition(numberPosition - 1);
    setFormValue({ ...formValue, position: updatedItems });
  };

  // DEFINE EXPERIENCE LIST FOR COLLAPSE
  const items: CollapseProps["items"] = [];
  if (data.experience && data.experience.length > 0) {
    formExpUpdate.forEach((element: any, idx: number) => {
      const selected = selectedExperience.includes(element.company_id);
      const item = {
        key: idx,
        label: (
          <CollapseHeader
            index={idx}
            activeKey={activeCollapseItem}
            formExpUpdate={formExpUpdate}
            setFormExpUpdate={handleSetFormExpUpdate}
            handleSetSelectedExperience={handleSetSelectedExperience}
            selectedExperience={selectedExperience}
          />
        ),
        children: (
          <CollapseContent
            index={idx}
            formExpUpdate={formExpUpdate}
            setFormExpUpdate={handleSetFormExpUpdate}
          />
        ),
      };
      items.push(item);
    });
  }

  // HANDLE EXPAND COLLAPSE
  const handleExpandCollapse = (type: string) => {
    if (type == "expand") {
      const tabKeys: any[] = [];
      {
        Array.from({ length: data?.experience?.length || 0 }).map(
          (_, index: number) => {
            tabKeys.push(index);
          }
        );
      }
      setActiveCollapseItem(tabKeys);
    } else {
      setActiveCollapseItem([]);
    }
  };

  return (
    <div className="ExperienceEdit">
      {/* EXPERIENCE LIST */}
      {!addExpFormVisible && data.experience!.length > 0 && (
        <>
          <div className="header-dash ps-3">
            <Checkbox
              checked={selectedExperience.length == formExpUpdate.length}
              onChange={(e) => handleSetSelectedExperience(e.target.checked)}
            ></Checkbox>
            <div className="header-action">
              <Button
                type="text"
                icon={<FullscreenOutlined className="action-icon" />}
                onClick={() => handleExpandCollapse("expand")}
              ></Button>
              <Button
                type="text"
                icon={<FullscreenExitOutlined className="action-icon" />}
                onClick={() => handleExpandCollapse("collapse")}
              ></Button>
              <Button
                color="danger"
                variant="filled"
                onClick={handleRemoveExperience}
                icon={<DeleteOutlined />}
              ></Button>
              <Button
                className="add-btn"
                onClick={() => setAddExpFormVisible(true)}
                icon={<PlusOutlined />}
              >
                Add
              </Button>
            </div>
          </div>
          <div className="experience-list mt-3">
            <Collapse
              items={items}
              collapsible={"icon"}
              expandIconPosition={"end"}
              activeKey={activeCollapseItem}
              onChange={(key: string[]) => setActiveCollapseItem(key)}
            />
          </div>
        </>
      )}

      {/* IF EXPERIENCE IS NOTHING */}
      {!addExpFormVisible && data.experience?.length == 0 && (
        <div className="add-section">
          <div className="title">
            Add a Position
            {guidePopover && <Callout setGuidePopover={setGuidePopover} />}
          </div>
          <div className="description">
            Recruiter and hiring managers are drawn to candidates who can
            showcase their relevant work history
          </div>
          <Button
            className="add-btn"
            onClick={() => setAddExpFormVisible(true)}
          >
            <img src={Coin} />
            +30
          </Button>
        </div>
      )}

      {/* ADD EXPERIENCE FORM */}
      {addExpFormVisible && (
        <Card
          title={<div className="exp-add-card">Add Experience</div>}
          extra={
            <Button
              type="text"
              icon={<CloseOutlined />}
              onClick={() => {
                setFormValue({
                  company_name: "",
                  position: [
                    {
                      position_name: "",
                      start_date: "",
                      end_date: "",
                      description: "",
                      skills: [],
                    },
                  ],
                });
                setAddExpFormVisible(false);
              }}
            ></Button>
          }
        >
          <div className="row mb-3">
            <div className="col-12">
              <div className="form-group">
                <div className="title">Company</div>
                <Input
                  size="large"
                  value={formValue.company_name}
                  onChange={(e) =>
                    handleSetFormValue(e.target.value, "company_name")
                  }
                  variant="filled"
                />
              </div>
            </div>
          </div>
          {Array.from({ length: numberPosition }).map((_, index) => (
            <ExpForm
              key={index}
              index={index}
              data={formValue.position[index]}
              setData={(value, key, index) =>
                handleSetFormValue(value, key, index)
              }
              removeForm={handleRemoveForm}
            />
          ))}
          <div className="text-center">
            <Button className="add-more-exp" onClick={handleAddExperienceForm}>
              <PlusOutlined />
              Another Experience
            </Button>
          </div>
        </Card>
      )}
    </div>
  );
};

export default ExperienceEdit;
